import { render, staticRenderFns } from "./BecomeCreatorContent.vue?vue&type=template&id=37a78302"
import script from "./BecomeCreatorContent.vue?vue&type=script&lang=js"
export * from "./BecomeCreatorContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports